<template>
  <div :class="classtrutt">
      <Chart :type="chartType" :data="computedChartData" :options="chartOptions" :class="classechart"/>
  </div>
</template>

<script>
import Chart from 'primevue/chart';

export default {
  name: "Grafici",
  components: { Chart },
  props: {
    files: {
      type: Array,
      required: true
    },
    classtrutt: {
      type: String,
      default: ''
    },
    translations: {
      type: Object,
      required: true
    },
    classechart: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default: null
    },
    chartType: {
      type: String,
      default: "doughnut"
    },
    colorPieno: {
      type: String,
      default: "#2C817C"
    },
    colorLibero: {
      type: String,
      default: "#F6F6F6"
    },
    alert50: {
      type: Boolean,
      default: false
    },
    alert100: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartItem() {
      const item = this.files[0];
      const spazioInGb = item.occupato;
      let liberoInGb = item.max_storage - spazioInGb;

      if(liberoInGb < 0) {
        liberoInGb = 0;
      }
      const colorPieno50 = this.alert50 ? "#B95504" : null;
      const colorPieno100 = this.alert100 ? "#7B1416" : null;
      console.log(colorPieno50);
      console.log(colorPieno100);
      const colorPieno = colorPieno100 || colorPieno50 || this.colorPieno;
      return {
        data: {
          datasets: [
            {
              data: [spazioInGb, liberoInGb],
              backgroundColor: [colorPieno, this.colorLibero],
              hoverBackgroundColor: [colorPieno, this.colorLibero],
            },
          ],
        }
      };
    },
    computedChartData() {
      return this.chartData ? this.chartData : this.chartItem ? this.chartItem.data : {};
    },
    chartOptions() {
      return {
        cutout: "85%",
        responsive: true,
      };
    }
  }
};
</script>

